import { render, staticRenderFns } from "./viewDocument.vue?vue&type=template&id=a83071ca&"
import script from "./viewDocument.vue?vue&type=script&lang=js&"
export * from "./viewDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports